import { match, P } from 'ts-pattern'

export function formatString(preformattedString?: string, ...args: Array<string | number>): string {
  if (typeof preformattedString !== 'string') {
    return ''
  }

  return preformattedString.replace(/{(\d+)}/g, (substring, i: number) => {
    return `${typeof args[i] !== 'undefined' ? args[i] : substring}`
  })
}

export const formatPrice = (price: string) =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(parseFloat(price.replace(',', '.')))

export function formatPhoneNumber(phoneNumber: string) {
  const cleaned = phoneNumber.replace(/\D/g, '')
  const regMatch = cleaned.match(/^(\d{3})(\d{3})(\d{4})(\d{0,4})$/)

  if (regMatch) {
    let phone = `(${regMatch[1]}) ${regMatch[2]}-${regMatch[3]}`

    if (regMatch[4]) {
      phone += ` x${regMatch[4]}`
    }

    return phone
  }

  return phoneNumber
}

export const formatDate = (date: string) =>
  new Date(date).toLocaleDateString('en-US', {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
  })

export const formatDateDayMonthYear = (date: string) =>
  new Date(date).toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  })
export const formatDateMonthYear = (date: string, forceCET: boolean = false) => {
  // Return 'August 2025'
  return new Date(date).toLocaleDateString('en-US', {
    month: 'long',
    year: 'numeric',
    timeZone: forceCET ? 'CET' : undefined,
  })
}

export const priceStringToNumber = (price: string) =>
  parseFloat(
    match(price)
      .with(
        P.when((p: string) => p.startsWith('-$')),
        () => price.replace(',', '').substring(2)
      )
      .with(
        P.when((p: string) => p.startsWith('$') || p.startsWith('-')),
        () => price.replace(',', '').substring(1)
      )
      .otherwise(() => price.replace(',', '.'))
  )
